<form [formGroup]="createAliasForm" (ngSubmit)="createAlias()">
  <div class="rs-form-item">
    <div class="rs-flex-row">
      <div class="small-12 medium-7 rs-flex-columns">
        <input
          type="text"
          name="alias"
          id="alias"
          data-cy="proximusAliasId"
          formControlName="alias"
          autocomplete="off"
          aria-describedby="ac-helper-alias4"
          [ngClass]="{ 'rs-filled': !isAliasEmpty() }"
        />
        <label class="rs-form-label" for="alias">{{
          'alias.creation.your.new.alias.placeholder' | translate
        }}</label>
      </div>
      <div class="small-12 medium-5 rs-flex-columns">
        <div class="rs-flex-columns rs-form-item">
          <select id="ac-selectbox1" name="domain" formControlName="domain" class="rs-filled">
            <option
              *ngFor="let availableDomain of mailbox.availableDomains"
              [value]="availableDomain"
            >
              @{{ availableDomain }}
            </option>
          </select>
          <label class="rs-form-label" for="ac-selectbox1">{{
            'alias.creation.domain.placeholder' | translate
          }}</label>
        </div>
      </div>
    </div>
    <div class="rs-form-helper" id="ac-helper-alias4">
      <ul>
        <li *ngIf="isAliasAvailable" class="rs-form-success">
          {{ 'aliases.available.title' | translate }}
        </li>
        <li
          *ngIf="isAliasFormHasErrors && createAliasForm.hasError('checkAlias')"
          class="rs-form-error"
        >
          {{ 'alias.creation.failure.not.unique.title' | translate }}
        </li>
        <li
          *ngIf="isAliasFormHasErrors && createAliasForm.hasError('networkError')"
          class="rs-form-error"
        >
          {{ 'mymail.app.error.network' | translate }}
        </li>
        <li
          *ngIf="isAliasFormHasErrors && createAliasForm.controls['alias'].hasError('required')"
          class="rs-form-error"
        >
          {{ 'create.mailbox.required.error' | translate }}
        </li>
        <li
          *ngIf="isAliasFormHasErrors && createAliasForm.controls['alias'].hasError('minlength')"
          class="rs-form-error"
        >
          {{ 'create.mailbox.minimum.length.error' | translate }}
        </li>
        <li
          *ngIf="isAliasFormHasErrors && createAliasForm.controls['alias'].hasError('maxlength')"
          class="rs-form-error"
        >
          {{ 'create.mailbox.maximum.length.error' | translate }}
        </li>
        <li
          *ngIf="
            isAliasFormHasErrors &&
            (createAliasForm.controls['alias'].hasError('pattern') ||
              createAliasForm.controls['alias'].hasError('whitespace') ||
              createAliasForm.controls['alias'].hasError('atSign')) &&
            createAliasForm.controls['alias'].value.length >= 2
          "
          class="rs-form-error"
        >
          {{ 'create.mailbox.pattern.error' | translate }}
        </li>
      </ul>
    </div>
  </div>
  <p class="right rs-margin-right2">
    <span *ngIf="showLoadingSpinner">
      <px-loading-spinner></px-loading-spinner>
    </span>
  </p>
  <button
    type="submit"
    class="rs-btn"
    [disabled]="!createAliasForm.valid || showLoadingSpinner"
    [ngStyle]="{
      'pointer-events': !createAliasForm.valid ? 'none' : 'auto',
      cursor: showLoadingSpinner ? 'not-allowed' : 'auto'
    }"
  >
    {{ 'aliases.create.button' | translate }}
  </button>
</form>
